<template>
    <div>
        <DCard
            padding
        >
            <FilesForm
                :customer-id="customerId"
                :customer-file="customerFile"
                :psa-orders="psaOrders"
                :errors="errors"
                @submit="storeFile"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import FilesForm from '~@/Components/Customers/Files/Form'

export default {
    name: 'CustomerFileEdit',
    components: {
        FilesForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        customerId: {
            type: Number,
            default: 0
        },
        customerFile: {
            type: Object,
            default: () => {
                return {}
            }
        },
        psaOrders: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        storeFile (form) {
            form.put(this.$route('customers.customers.customer-files.update', {
                customer: this.customerId,
                customer_file: this.customerFile
            }))
        }
    }
}
</script>
